import { render, staticRenderFns } from "./AdminPlusDrawer.vue?vue&type=template&id=1b7fb35d&scoped=true"
import script from "./AdminPlusDrawer.vue?vue&type=script&lang=js"
export * from "./AdminPlusDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdminPlusDrawer.vue?vue&type=style&index=0&id=1b7fb35d&prod&scoped=true&lang=css"
import style1 from "./AdminPlusDrawer.vue?vue&type=style&index=1&id=1b7fb35d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7fb35d",
  null
  
)

export default component.exports